module.exports = __webpack_public_path__ + "static/media/049.f5917d00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/049.jpg
// module id = 344
// module chunks = 0